export default {
    loading: 'monitor:operating:loading',
    search: 'monitor:operating:search',
    logs: 'monitor:operating:logs',
}


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/phoneDetail/constant.js